import React from 'react';
import { Box, Container, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';

const Footer = () => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        py: 4,
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.secondary.main,
      }}
    >
      <Container maxWidth="lg">
        <Typography
          variant="body2"
          sx={{
            textAlign: 'center',
            color: 'rgba(255,255,255,0.8)',
          }}
        >
          © {new Date().getFullYear()} JOCAST Machining. All rights reserved.
        </Typography>
      </Container>
    </Box>
  );
};

export default Footer;
